module.exports = __webpack_public_path__ + "img/num-2.70d7383d.svg";